<template>
  <div class="tab-bot">
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item badge="3">
        <span>自定义</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">标签</van-tabbar-item>
      <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
    </van-tabbar> -->

    <van-tabbar
      v-model="active"
      route
      active-color="#E23130"
      inactive-color="#484848"
      :placeholder="true"
      class="fl-tabbar"
      z-index="999"
      fixed
      safe-area-inset-bottom
    >
      <van-tabbar-item
        v-for="(item, index) in icon"
        :key="index"
        :to="{
          name: item.link
        }"
      >
        <template #icon slot-scope="props">
          <div class="tabs-item">
            <img :src="props.active ? item.active : item.inactive" />
            <span>{{ item.name }}</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <!-- <van-tabbar fixed class="footNav" style="z-index: 99; box-shadow: 0rem 0rem .02rem .01rem #f2f2f2">
      <van-tabbar-item to="/" class="theme-col">
        <span :class="{ 'theme-col': router == 'Home' }">首页</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-shouye" :class="{ 'theme-col': router == 'Home' }" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/goodstype">
        <span :class="{ 'theme-col': router == 'Goodstype' }">分类</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-fenlei" :class="{ 'theme-col': router == 'Goodstype' }" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/user/cart">
        <span :class="{ 'theme-col': router == 'Cart' }">{{ $common.cardName().name }}</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-gouwuche" :class="{ 'theme-col': router == 'Cart' }" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/user">
        <span :class="{ 'theme-col': router == 'User' }">我的</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-wode" :class="{ 'theme-col': router == 'User' }" />
        </template>
      </van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
export default {
  name: 'footernav',
  data() {
    return {
      active: 0,
      icon: [
        {
          name: '首页',
          active: require('./../assets/img/1-2.svg'),
          inactive: require('./../assets/img/1-1.svg'),
          link: 'Home'
        },
        {
          name: '分类',
          active: require('./../assets/img/3-2.svg'),
          inactive: require('./../assets/img/3-1.svg'),
          link: 'Goodstype'
        },
        {
          name: this.$common.cardName().name,
          active: require('./../assets/img/2-2.svg'),
          inactive: require('./../assets/img/2-1.svg'),
          link: 'Cart'
        },
        {
          name: '我的',
          active: require('./../assets/img/4-2.svg'),
          inactive: require('./../assets/img/4-1.svg'),
          link: 'User'
        }
      ]
    }
  },
  computed: {
    router() {
      return this.$route.name
    }
  },
  methods: {
    beforeChange() {}
  }
}
</script>

<style lang="less">
.tab-bot {
  height: 1rem;
  .van-tabbar {
    // border-top: 1px solid #f5f5f5;
    padding: 0.1rem 0;
    box-shadow: 0px 0px .16rem 0px rgba(0, 0, 0, 0.08);
  }
  .tabs-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 0.52rem;
      height: 0.52rem;
      margin-bottom: 0.05rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footernav.vue